import { render, staticRenderFns } from "./NetworkUsageGraph.vue?vue&type=template&id=3b12bd5b&scoped=true&"
import script from "./NetworkUsageGraph.vue?vue&type=script&lang=js&"
export * from "./NetworkUsageGraph.vue?vue&type=script&lang=js&"
import style0 from "./NetworkUsageGraph.vue?vue&type=style&index=0&id=3b12bd5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12bd5b",
  null
  
)

export default component.exports